module.exports = __webpack_public_path__ + "static/media/image.bb34ec45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/DarthVader/image.jpg
// module id = 26
// module chunks = 0